<dx-page [options]="pageOptions">
  <ng-container *dxPageHeader>
    <ng-container *ngTemplateOutlet="errorPageHeader || defaultErrorPageHeaderTemplate"></ng-container>

    <ng-template #defaultErrorPageHeaderTemplate>
      <dx-page-header></dx-page-header>
    </ng-template>

  </ng-container>

  <ng-container *dxPageContent>
    <ng-container *ngIf="errorTitle; else report">
        <h1>{{errorTitle}}</h1>
        <div class="dx-error-report__message">{{errorMessage}}</div>

        <!-- Возврат обратно на ту или иную страницу системы -->
        <div class="dx-error-report__back_to_app_block">
          <a class="dx-error-report__btn  dx-error-report__btn--c1"
             (click)="onGoBackToApp()">
            Вернуться в систему
          </a>
        </div>
    </ng-container>
    <ng-template #report>
        <div class="dx-error-report"
             [error]="error"
             [showGoBackBtn]="isGoBackRoteProvided"
             (goBackClick)="onGoBackToApp()"
             (submitErrorReportClick)="onSubmitErrorReport()">
        </div>
    </ng-template>
  </ng-container>

  <!-- Футер с указанием координат технической поддержки -->
  <ng-container *dxPageFooter>
    <div class="dx-tech-support">
      <div class="dx-tech-support__text">Техподдержка: +7 965 562 31 96</div>
    </div>
  </ng-container>
</dx-page>
